import { useOnClickOutside } from "@qastanfit/qastan-ui"
import styles from "../../styles/components/Navigation.module.scss"
import chevron from "../assets/icons/chevron_right_white.svg";
import boxlogo from "../../assets/logo/boxlogo.svg";
import boxlogo_letters from "../assets/logo/boxlogo_letters.svg";
import { useState, useEffect, useRef, MutableRefObject } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import { motion, AnimatePresence } from "framer-motion"
import { RootState } from "../../store";

export default function Navigation(){
    const navigate = useNavigate();
    const userdata:UserData = useAppSelector((state:RootState) => state.userdata);

    const [showProfileMenu, setshowProfileMenu] = useState(false);
    const [showNavigationMobile, setshowNavigationMobile] = useState(false);

    const [activePage, setactivePage] = useState("home");

    useEffect(()=>{
        handleSetActivePage()

        window.addEventListener("popstate", handleSetActivePage);

        return () => {
            window.removeEventListener("popstate", handleSetActivePage);
        };
    }, [])

    const handleSetActivePage = () => {
        if(window.location.pathname.split("/")[2]){
            if(window.location.pathname.split("/")[2].includes("port")){
                setactivePage(window.location.pathname.split("/")[3])
            }
            else {
                setactivePage(window.location.pathname.split("/")[2])
            }
            
        }
        else {
            setactivePage(window.sessionStorage.getItem("activePage") || "home");
        }
    }

    const logout = () => {
        window.localStorage.removeItem("RememberMe");
        navigate("/")
    }

    const navigatePortal = (e:any, link:string) => {
        setshowNavigationMobile(!showNavigationMobile)
        navigate(link);
        setactivePage(link);
        window.sessionStorage.setItem("activePage", link)
    }

    const indicatorRef = useRef() as MutableRefObject<HTMLDivElement>;
    const topRef = useRef() as MutableRefObject<HTMLDivElement>

    const moveIndicator = (e:React.MouseEvent) => {
        let target = e.currentTarget;
        if(target instanceof HTMLDivElement){
            let offsetTop = target.offsetTop;
            indicatorRef.current.style.top = offsetTop + "px"
        }
    }

    const moveToActive = () => {
        let activeTarget = document.getElementById(activePage);
        if(activeTarget instanceof HTMLDivElement){
            let offsetTop = activeTarget.offsetTop;
            indicatorRef.current.style.top = offsetTop + "px"
        }
    }

    const menuRef = useRef() as MutableRefObject<HTMLDivElement>
    useOnClickOutside(menuRef, () => { if(showProfileMenu){ setshowProfileMenu(false) } })

    const navigatePage = (page:string) => {
        navigate(page)
        setactivePage(page)
    }

    return (
        <div className={styles.nav}>
            <div className={styles.ct}>
                <div ref={topRef} className={styles.top}>
                    <img className={styles.logo} src={boxlogo} alt="logo" />
                </div>
                <div onMouseLeave={()=>{moveToActive()}} className={styles.items}>
                    <div ref={indicatorRef} className={styles.indicator}></div>

                    <div onClick={()=>{navigatePage("home")}} id="home" onMouseEnter={(e)=>{moveIndicator(e)}} className={`${activePage === "home" && styles.item_active} ${styles.item}`}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 10.5L14 2.33334L24.5 10.5V23.3333C24.5 23.9522 24.2542 24.5457 23.8166 24.9833C23.379 25.4208 22.7855 25.6667 22.1667 25.6667H5.83333C5.21449 25.6667 4.621 25.4208 4.18342 24.9833C3.74583 24.5457 3.5 23.9522 3.5 23.3333V10.5Z" stroke="#B7B7B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10.5 25.6667V14H17.5V25.6667" stroke="#B7B7B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>                        
                        <p className={styles.label}>Home</p>
                    </div>

                    <div onClick={()=>{navigatePage("vertalingen")}} id="vertalingen" onMouseEnter={(e)=>{moveIndicator(e)}} className={`${activePage === "vertalingen" && styles.item_active} ${styles.item}`}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.8333 22.1667C17.988 22.1667 22.1667 17.988 22.1667 12.8333C22.1667 7.67868 17.988 3.5 12.8333 3.5C7.67868 3.5 3.5 7.67868 3.5 12.8333C3.5 17.988 7.67868 22.1667 12.8333 22.1667Z" stroke="#B7B7B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M24.5 24.5L19.425 19.425" stroke="#B7B7B7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                        <p className={styles.label}>Vertalingen</p>
                    </div>

                </div>
            </div>
            <div className={styles.ft}>
                <div onClick={()=>{setshowProfileMenu(true)}} className={styles.profile}>
                    <div className={styles.picture}>{userdata.user.name?.charAt(0)}</div>
                    <p className={styles.name}>{userdata.user.name}</p>
                    <svg className={styles.triangle} xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="m80 896 401-640 399 640H80Z"/></svg>
                </div>
                <div ref={menuRef} className={`${!showProfileMenu && styles.menu_hidden} ${styles.menu}`}>
                    <div onClick={()=>{logout()}} className={styles.m_item}>
                        <svg className={styles.icon} viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                        <p>Uitloggen</p>
                    </div> 
                </div>
            </div>
        </div>
    )
}